import { Component, Input, OnChanges, OnInit, Pipe, PipeTransform } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { combineLatest, merge, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LogCategory, LoggerService, LogPage, LogType } from 'src/app/core/services/logger.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { ProfileService } from '../../../core/services/profile.service';
import { UtilityService } from '../../../core/services/utility.service';
import { FacultyService } from '../../../services/faculty.service';

@Component({
    selector: 'syllabus-update-modal',
    templateUrl: './syllabus-update-modal.component.html',
    styleUrls: ['./syllabus-update-modal.component.scss'],
    standalone: false
})
export class SyllabusUpdateModalComponent implements OnInit {
     
    @Input() section: any;
    
   
    selectedSections: number[] = [];
    searchSections: string[] = [];
    filename: any;
    file: any;
    updatedSections$: Observable<any>;
    sectionsByProgram$: Subject<any> = new Subject();

    uploadError: boolean = false;
    uploadSuccess: boolean = false;
    uploadFileSizeError: boolean = false;
    uploading: boolean = false;
    tabToShow: string = 'new';
    academicYear: string = '';
    academicTerm: string = '';
    active: string = 'upload';
    selectedFileName: string = '';

    today = this.utility.getCurrentDate().toISOString();

    constructor(
        private logger: LoggerService,
        public activeModal: NgbActiveModal,
        public facultyService: FacultyService,
        public profileService: ProfileService,
        public auth: AuthenticationService,
        public utility: UtilityService
    ) {
        this.selectedSections = [];
        this.log("constructor", "syllabus update modal", LogCategory.Constructor);
        this.updatedSections$ = combineLatest([merge(this.facultyService.copySyllabi$, this.facultyService.uploadSyllabus$), this.sectionsByProgram$]).pipe(
            tap(([result, sectionsByProgram]) => {
                this.uploading = false;
                var sections = sectionsByProgram.flatMap(s => s.sections);
                if (result.Data) {
                    var sectionsToUpdate = sections.filter(s => result.Data.indexOf(s.SectionId) > -1);
                    sectionsToUpdate.forEach(s => {
                        s.HasSyllabus = true;
                    });
                }
                this.activeModal.close();
                this.facultyService.syllabusResultModal(result);
            }));

    }

    ngOnInit() {
        this.section.isSyllabusSelected = true;
        this.selectedSections.push(this.section.SectionId);
        this.academicYear = this.section.AcademicYear.slice(0, 4);        
    }

    toggleActiveButton(el): void {
        this.active = el;
    } 

    toggleSection(sectionId: number) {
        if (this.selectedSections.indexOf(sectionId)<=-1) {
            this.selectedSections.push(sectionId);
        } else {
            var index = this.selectedSections.indexOf(sectionId);
            this.selectedSections.splice(index, 1);
        }
    }

    updateFile(event) {
        if (event.target.files.length > 0) {           
                // Limited to files of 4Mb only, to increase this you also need to update the web.config. See this article: https://stackoverflow.com/questions/3853767/maximum-request-length-exceeded
            if (event.target.files[0].size > 4194304) {
                this.uploadFileSizeError = true;
            } else {
                this.uploadFileSizeError = false;
                this.file = event.target.files[0];
                this.selectedFileName = this.file.name;
            }
        }
    }

    uploadSyllabus(sectionsByProgram) {
        if (this.active == 'copy') {
            this.uploading = true;
            this.facultyService.copyFile$.next({
                courseNumber: this.section.CourseNumber,
                academicTerm: this.academicTerm,
                academicYear: this.academicYear,
                selectedSections: this.selectedSections
            });
         
        } else {
            this.uploading = true;
            this.facultyService.uploadFile$.next({ file: this.file, selectedSections: this.selectedSections });
        }

        this.sectionsByProgram$.next(sectionsByProgram);

        this.selectedSections = [];
    }

    closeModal(reason, sectionsByProgram) { 
        var sections = sectionsByProgram.flatMap(s => s.sections);
        sections.forEach(s => s.isSyllabusSelected = false);
        this.selectedSections = [];
        this.activeModal.dismiss(reason);
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogPage.Courses, category);
    }
}

@Pipe({
    name: 'classSyllabusFilter',
    standalone: false
})

export class FacultySyllabusFilterPipe implements PipeTransform {
    constructor(private utility: UtilityService) { }
    transform(item: any, courseCode: any, selectedId: number): any {
        if (!item) return '';

        var today = this.utility.getCurrentDate().toISOString();
        var sections = item.filter(s => s.Key.indexOf(courseCode) > -1)
            .flatMap(s => s.Sections);
               
        var sectionsByProgram = sections
            .filter(s => s.EndDate > today)
            .reduce((acc, obj) => {
                const program = obj['Program'];

                //  On init, reset the selected section if it was not set to the origin sectionId
                if ((obj.SectionId != selectedId) && obj.isSyllabusSelected)
                    delete obj.isSyllabusSelected;

                if (!acc[program]) {
                    acc[program] = { 'program': program, sections: [] }
                }
                acc[program].sections.push(obj);
                return acc;
            }, {});

        return Object.values(sectionsByProgram);       
    }
}

@Pipe({
    name: 'sectionOnlySyllabusFilter',
    standalone: false
})

export class FacultySyllabusClassFilterPipe implements PipeTransform {
    transform(item: any): any {
        if (!item) return '';

        return item.flatMap(i => i.sections);        
    }
}



